import { Instance, types } from "mobx-state-tree"

export const UserTypeModel = types.model("UserType").props({
  id: types.identifier,
  name: types.string,
  auth_type: types.maybeNull(types.string)
})

export interface UserType extends Instance<typeof UserTypeModel> {}